import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const BLOCKER_CONTEXT_SYMBOL = Symbol();
const useBlocker = ()=>useImmutableContext(BLOCKER_CONTEXT_SYMBOL);
const useBlockerProvider = (...args)=>useImmutableContextProvider(BLOCKER_CONTEXT_SYMBOL, ...args);
export { useBlocker, useBlockerProvider };
